// extracted by mini-css-extract-plugin
export var fontSerif = "portableText-module--font-serif--X4O3c";
export var rte = "portableText-module--rte--1-k7p";
export var rteImage = "portableText-module--rteImage--iiGv8";
export var triggerSpan = "portableText-module--triggerSpan--a6bpZ";
export var triggerSpanTexture = "portableText-module--triggerSpanTexture--flmWU";